import React from 'react';
import { useActiveSession } from './ActiveSessionContext';
import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase'; // adjust the path if needed
import { useAuth } from './AuthProvider'; // adjust path if needed
import dexie from './offlineDB';

export default function SessionBanner() {
  const { activeSession: session, setActiveSession: setSession } = useActiveSession();
  console.log('[SessionBanner] Session:', session);
  const { user } = useAuth();

  if (!session) return null;

  
const handleStop = async () => {
  if (window.confirm('End the current session?')) {
    try {
const ref = doc(db, 'users', user.uid, 'sessions', session.id);
const endedAt = new Date().toISOString(); // use ISO string as offline stand-in

if (navigator.onLine) {
  await updateDoc(ref, { endedAt: serverTimestamp() });
} else {
  await dexie.sessions.update(session.id, { endedAt });
  await dexie.pendingWrites.add({
    type: 'update',
    collection: 'sessions',
    docId: session.id,
    data: { endedAt }
  });
}

    } catch (err) {
      console.error('Failed to log session end:', err);
    }
    setSession(null);
  }
};



  const isDark = document.body.classList.contains('theme-dark');

  return (
    <div style={{
      background: isDark ? '#333' : '#f5f5f5',
      color: isDark ? '#fff' : '#000',
      borderBottom: '1px solid #ccc',
      padding: '10px 16px',
      textAlign: 'center',
      fontSize: '14px',
      width: '100%',
      zIndex: 9999,
      position: 'relative',
      marginTop: '60px'  // push below nav bar if it's fixed
    }}>
      🟢 Session started: <strong>{session.location}</strong> — <em>{new Date(session.startedAt).toLocaleString()}</em>
      <button onClick={handleStop} style={{
        marginLeft: '20px',
        padding: '4px 10px',
        fontSize: '12px',
        background: 'crimson',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer'
      }}>Stop Session</button>
    </div>
  );
}
